/**
 * [AYNI] Carousel Slides Popup
 * Öffnet/schließt das Bottom-Sheet-Overlay des Blocks
 * snippets/ayni-carousel-slides-popup-block.liquid.
 *
 * WICHTIG — Event-Delegation statt direkter Listener:
 * Der Farb-Variant-Wechsel (sht-variation, siehe theme.js) ersetzt bei
 * einem Klick auf ein Farb-Swatch den kompletten Inhalt der Produkt-Info-
 * Sektion per `innerHTML =`. Dabei werden alle bis dahin per
 * addEventListener() gebundenen Handler verworfen (die alten DOM-Knoten
 * werden zerstört) UND neu eingefügte <script>-Tags werden vom Browser
 * NICHT erneut ausgeführt (Standardverhalten bei innerHTML-Insertion).
 *
 * Bisherige Version band Listener direkt an .acsp-overlay / .acsp__link /
 * .acsp-overlay__sheet — nach einem Variant-Wechsel waren diese Knoten
 * neu und tot (kein Klick-Handler mehr).
 *
 * Fix: Alle Listener hängen jetzt nur EINMALIG an `document` und arbeiten
 * über e.target.closest(...). Das überlebt jeden DOM-Austausch, weil
 * document selbst nie ersetzt wird.
 */
(function () {
  'use strict';

  if (window.__acspBound) return;
  window.__acspBound = true;

  function getSheet(overlay) {
    return overlay.querySelector('.acsp-overlay__sheet');
  }

  function openOverlay(overlay) {
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeOverlay(overlay) {
    var sheet = getSheet(overlay);
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (sheet) sheet.style.transform = '';
  }

  // ─── Open / Close Trigger (delegiert) ───
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-acsp-trigger]');
    if (trigger) {
      e.preventDefault();
      var overlayId = trigger.getAttribute('aria-controls');
      var overlay = overlayId && document.getElementById(overlayId);
      if (overlay) openOverlay(overlay);
      return;
    }

    var closer = e.target.closest('[data-acsp-close]');
    if (closer) {
      var closeOverlayEl = closer.closest('.acsp-overlay');
      if (closeOverlayEl) closeOverlay(closeOverlayEl);
    }
  });

  // ─── Escape zum Schließen (delegiert) ───
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openOverlayEl = document.querySelector('.acsp-overlay.is-open');
    if (openOverlayEl) closeOverlay(openOverlayEl);
  });

  // ─── Swipe-to-close (delegiert, Zustand als Expando am Sheet-Knoten) ───
  document.addEventListener('touchstart', function (e) {
    var sheet = e.target.closest('.acsp-overlay__sheet');
    if (!sheet) return;
    sheet.__acspTouchStartY = e.touches[0].clientY;
    sheet.__acspDrag = 0;
    sheet.setAttribute('data-dragging', '');
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    var sheet = e.target.closest('.acsp-overlay__sheet[data-dragging]');
    if (!sheet) return;
    var delta = e.touches[0].clientY - sheet.__acspTouchStartY;
    if (delta > 0) {
      sheet.__acspDrag = delta;
      sheet.style.transform = 'translateY(' + delta + 'px)';
    }
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var sheet = e.target.closest('.acsp-overlay__sheet[data-dragging]');
    if (!sheet) return;
    sheet.removeAttribute('data-dragging');
    if (sheet.__acspDrag > 120) {
      var overlay = sheet.closest('.acsp-overlay');
      if (overlay) closeOverlay(overlay);
    } else {
      sheet.style.transform = '';
    }
    sheet.__acspDrag = 0;
  });

  // ─── Focus trap (delegiert; nur ein Overlay ist je Instanz offen, block "limit": 1) ───
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var overlay = document.querySelector('.acsp-overlay.is-open');
    if (!overlay) return;
    var focusable = overlay.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey ? document.activeElement === first : document.activeElement === last) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    }
  });
})();